import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { IonicModule } from "@ionic/angular";
import { PipesModule } from "../pipes/pipes.module";
import { PopoverContentComponent } from "./popover-content/popover-content.component";
import { PopoverIframeComponent } from "./popover-iframe/popover-iframe.component";
import { PopoverSessionStatsComponent } from "./popover-session-stats/popover-session-stats.component";
import { PopoverReconfirmationComponent } from "./popover-reconfirmation/popover-reconfirmation.component";
import { PopoverSelfExcludeComponent } from "./popover-self-exclude/popover-self-exclude.component";
import { VipTermsComponent } from "./popover-vipterms/popover-vipterms.component";
import { PopoverAlertComponent } from "./popover-alert/popover-alert.component";
import { ComponentsModule } from "../components/components.module";
import { PopoverStandardConfirmComponent } from "./popover-standard-confirm/popover-standard-confirm.component";
import { PopoverWebviewComponent } from "./popover-webview/popover-webview/popover-webview.component";
import { PopoverGameHistoryDetailsComponent } from "./popover-game-history-details/popover-game-history-details.component";
import { PopoverMarketingComponent } from "./popover-marketing/popover-marketing.component";
import { PopoverAgreementComponent } from "./popover-agreement/popover-agreement.component";
import { PopoverDarkWebviewComponent } from "./popover-webview/popover-dark-webview/popover-dark-webview.component";
import { FancyPopoverComponent } from "./fancy-popover/fancy-popover.component";
import { BonusContentPage } from "./bonus-content/bonus-content.page";
import { PopoverProcessingComponent} from "./popover-processing/popover-processing.component"
import { StandardPopoverPage} from "./standard-popover/standard-popover.page"
import { PopoverTrackConsentComponent } from "./popover-track-consent/popover-track-consent.component";
import { PopoverBiometricComponent} from "./popover-biometric/popover-biometric.component"
import { directivesModule } from "../directives/directives.module";
import { GlobalErrorBlockSitePopover } from "./global-error-block-site/global-error-block-site";

@NgModule({
    imports:[
        CommonModule,
        IonicModule,
        BrowserModule,
        FormsModule,
        directivesModule,
        PipesModule,
        ReactiveFormsModule,
        ComponentsModule,
    ],
    declarations: [
      FancyPopoverComponent,
      VipTermsComponent,
      PopoverAlertComponent,
      PopoverIframeComponent,
      PopoverContentComponent,
      PopoverSessionStatsComponent,
      PopoverReconfirmationComponent,
      PopoverSelfExcludeComponent,
      PopoverStandardConfirmComponent,
      PopoverDarkWebviewComponent,
      PopoverWebviewComponent,
      PopoverGameHistoryDetailsComponent,
      PopoverMarketingComponent,
      PopoverAgreementComponent,
      PopoverProcessingComponent,
      BonusContentPage,
      StandardPopoverPage,
      PopoverTrackConsentComponent,
      PopoverBiometricComponent,
      GlobalErrorBlockSitePopover
    ],
    exports: [
    ]
})

export class PopoverModule {}